module.exports = __webpack_public_path__ + "img/fy_ic_vip.ebe4c3f7.png";